import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../components/constants';

// Async thunk for fetching all users
export const fetchAllUsers = createAsyncThunk(
  'users/fetchAllUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/users`);
      console.log(response,'response')
      return response.data.users;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch users');
    }
  }
);

// Async thunk for updating user role
export const updateUserRole = createAsyncThunk(
  'users/updateRole',
  async ({ userEmail, newRole }, { rejectWithValue }) => {
    try {
      await axios.put(`${BASE_URL}/users/role`, {
        user_email: userEmail,
        new_role: newRole
      });
      return { userEmail, newRole };
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to update role');
    }
  }
);

const initialState = {
  users: [],
  status: 'idle',
  error: null,
  updateStatus: 'idle',
  updateError: null
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    resetUsers: (state) => {
      state.users = [];
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.users = action.payload;
        state.error = null;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(updateUserRole.pending, (state) => {
        state.updateStatus = 'loading';
        state.updateError = null;
      })
      .addCase(updateUserRole.fulfilled, (state, action) => {
        state.updateStatus = 'succeeded';
        state.updateError = null;
        const { userEmail, newRole } = action.payload;
        const user = state.users.find(u => u.user_email === userEmail);
        if (user) {
          user.user_role = newRole;
        }
      })
      .addCase(updateUserRole.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.updateError = action.payload;
      });
  }
});

export const { resetUsers } = usersSlice.actions;
export const selectAllUsers = (state) => state.users.users;
export const selectUsersStatus = (state) => state.users.status;
export const selectUsersError = (state) => state.users.error;
export const selectUpdateStatus = (state) => state.users.updateStatus;
export const selectUpdateError = (state) => state.users.updateError;

export default usersSlice.reducer;
